<template>
  <a-form :form="form" @submit.prevent="handleConfigInfoSubmit">
    <a-row class="content-panle margin-0 padding-tb-0" :gutter="30">
      <!-- 门禁设置 -->
      <a-col :span="24" class="padding-tb-md">
        <h3 class="panle-head">{{ $t('devicesManaConfig.gate.gateTitle') }}</h3>
        <!-- 是否启用门禁功能 -->
        <a-col :span="8">
          <a-form-item
            :label="$t('devicesManaConfig.gate.enableAccessControl')"
          >
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="[
                'enableDoorAccess',
                { initialValue: deviceConfig.enableDoorAccess || '1' }
              ]"
              @change="handleChangeEnableDoorAccess"
            >
              <a-select-option value="1">{{
                $t('devicesManaConfig.gate.option_true')
              }}</a-select-option>
              <a-select-option value="2">{{
                $t('devicesManaConfig.gate.option_false')
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 是否启用直接开门功能 -->
        <!-- <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.gate.enableOpenDirectly')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="['enableDirectOpen',{ initialValue: deviceConfig.enableDirectOpen || '2' }]"
              @change="handleChangeEnableDirectOpen"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.gate.option_true')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.gate.option_false')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->
        <!-- 关门延时 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.gate.closingDelay')">
            <a-input
              :disabled="closeDoorAccess"
              :placeholder="$t('devicesManaConfig.gate.closingDelayTxt')"
              :suffix="$t('devicesManaConfig.gate.closingDelayUnit')"
              v-decorator="[
                'closeDelay',
                {
                  initialValue: deviceConfig.closeDelay || '5',
                  rules: [
                    {
                      required: !closeDoorAccess,
                      message: $t('devicesManaConfig.gate.closingDelayBlank')
                    },
                    {
                      pattern: /^[1-9]\d*$/,
                      message: $t('devicesManaConfig.gate.closingDelayWarning')
                    },
                    {
                      validator: checkCloseDelayRange,
                      trigger: ['blur', 'change']
                    }
                  ]
                }
              ]"
            ></a-input>
          </a-form-item>
        </a-col>
        <!-- 通讯方式 -->
        <a-col :span="8">
          <a-form-item
            :label="$t('devicesManaConfig.gate.communicationMethods')"
          >
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              mode="multiple"
              :disabled="closeDoorAccess"
              :placeholder="
                $t('devicesManaConfig.gate.communicationMethodsTxt')
              "
              v-decorator="[
                'doorOpenMode',
                {
                  initialValue: deviceConfig.doorOpenMode || ['1'],
                  rules: [
                    {
                      required: !closeDoorAccess,
                      message: $t(
                        'devicesManaConfig.gate.communicationMethodsBlank'
                      )
                    }
                  ]
                }
              ]"
            >
              <a-select-option value="1">{{
                $t('devicesManaConfig.gate.option_relay')
              }}</a-select-option>
              <a-select-option value="2">{{
                $t('devicesManaConfig.gate.option_wiggins26')
              }}</a-select-option>
              <a-select-option value="3">{{
                $t('devicesManaConfig.gate.option_wiggins34')
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 识别方式 -->
        <a-col :span="16">
          <a-form-item :label="$t('devicesManaConfig.gate.identifyWays')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              mode="multiple"
              :disabled="closeDoorAccess || isDirectOpen"
              :placeholder="$t('devicesManaConfig.gate.identifyWaysTxt')"
              v-decorator="[
                'recognMode',
                {
                  initialValue: deviceConfig.recognMode || ['1', '2'],
                  rules: [
                    {
                      required: !closeDoorAccess && !isDirectOpen,
                      message: $t('devicesManaConfig.gate.identifyWaysBlank')
                    }
                  ],
                  validateTrigger: ['change', 'blur']
                }
              ]"
              @change="handleRecognModeChange"
            >
              <a-select-opt-group label="鉴权方式">
                <a-select-option value="1">{{
                  $t('devicesManaConfig.gate.option_ICCard')
                }}</a-select-option>
                <a-select-option value="2">{{
                  $t('devicesManaConfig.gate.option_face')
                }}</a-select-option>
                <a-select-option value="3">{{
                  $t('devicesManaConfig.gate.option_IDCard')
                }}</a-select-option>
                <a-select-option value="4">{{
                  $t('devicesManaConfig.gate.option_ICAndFR')
                }}</a-select-option>
              </a-select-opt-group>
              
              <a-select-opt-group label="采集方式">
                <a-select-option value="5">{{
                  $t('devicesManaConfig.gate.option_IDAndFaceComparison')
                }}</a-select-option>
                <a-select-option value="6">{{
                  $t('devicesManaConfig.gate.option_FaceCollection')
                }}</a-select-option>
                <a-select-option value="7">{{
                  $t('devicesManaConfig.gate.option_IDCollection')
                }}</a-select-option>
                <a-select-option value="8">{{
                  $t('devicesManaConfig.gate.option_IDAndSitePhoto')
                }}</a-select-option>
                <!-- <a-select-option value="9" disabled="">{{
                  $t('devicesManaConfig.gate.option_DynamicKey')
                }}</a-select-option> -->
              </a-select-opt-group>
              
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 是否启用识别提示闪烁 -->
        <a-col :span="8">
          <a-form-item
            :label="$t('devicesManaConfig.gate.enableRecogFlashing')"
          >
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="[
                'enableRecognBlink',
                { initialValue: deviceConfig.enableRecognBlink || '1' }
              ]"
            >
              <a-select-option value="1">{{
                $t('devicesManaConfig.gate.option_true')
              }}</a-select-option>
              <a-select-option value="2">{{
                $t('devicesManaConfig.gate.option_false')
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 是否启用识别提示声音 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.gate.enableRecogVoice')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="[
                'enableRecognVoice',
                { initialValue: deviceConfig.enableRecognVoice || '1' }
              ]"
            >
              <a-select-option value="1">{{
                $t('devicesManaConfig.gate.option_true')
              }}</a-select-option>
              <a-select-option value="2">{{
                $t('devicesManaConfig.gate.option_false')
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 门禁方向 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.gate.doorDirection')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="[
                'doorDirection',
                { initialValue: deviceConfig.doorDirection || '1' }
              ]"
            >
              <a-select-option value="1">{{
                $t('devicesManaConfig.gate.option_enter')
              }}</a-select-option>
              <a-select-option value="2">{{
                $t('devicesManaConfig.gate.option_out')
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 设置为签到设备 -->
        <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.gate.setSignInDevice')">
            <a-select
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="['signIn', { initialValue: signIn }]"
            >
              <a-select-option value="true">{{
                $t('devicesManaConfig.gate.option_true')
              }}</a-select-option>
              <a-select-option value="false">{{
                $t('devicesManaConfig.gate.option_false')
              }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 访客身份类型 -->
        <!-- <a-col :span="8">
          <a-form-item :label="$t('devicesManaConfig.gate.visitorType')">
            <a-select
              :disabled="isDirectOpen"
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              v-decorator="['visitorType', { initialValue: deviceConfig.visitorType || '1' }]"
              @change="value => visitorType = value"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.gate.options_scheduled')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.gate.options_temporary')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->
        <!-- 访客识别方式 -->
        <!-- <a-col :span="16" v-if="visitorType === '1'">
          <a-form-item :label="$t('devicesManaConfig.gate.scheduledVIdentifyWays')">
            <a-select
              :disabled="isDirectOpen"
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              mode="multiple"
              :placeholder="$t('devicesManaConfig.gate.scheduledVIdentifyWaysTxt')"
              v-decorator="[
                'S_visitorRecognMode',
                {
                  initialValue: S_visitorRecognMode,
                  rules: [{
                    required: !isDirectOpen, 
                    message: $t('devicesManaConfig.gate.scheduledVIdentifyWaysBlank')
                  }]
                }
              ]"
              @change="handleSVisitorRecognModeChange"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.gate.option_IDCard')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.gate.option_face')}}</a-select-option>
              <a-select-option value="3">{{$t('devicesManaConfig.gate.option_IDAndFace')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->
        <!-- <a-col :span="16" v-if="visitorType === '2'">
          <a-form-item :label="$t('devicesManaConfig.gate.temporaryVIdentifyWays')">
            <a-select
              :disabled="isDirectOpen"
              dropdownClassName="form-select"
              :getPopupContainer="trigger => trigger.parentNode"
              :placeholder="$t('devicesManaConfig.gate.temporaryVIdentifyWaysTxt')"
              v-decorator="[
                'T_visitorRecognMode',
                {
                  initialValue: T_visitorRecognMode,
                  rules: [{
                    required: !isDirectOpen, 
                    message: $t('devicesManaConfig.gate.temporaryVIdentifyWaysBlank')
                  }]
                }
              ]"
            >
              <a-select-option value="1">{{$t('devicesManaConfig.gate.option_IDCardCollection')}}</a-select-option>
              <a-select-option value="2">{{$t('devicesManaConfig.gate.option_personAndID')}}</a-select-option>
              <a-select-option value="3">{{$t('devicesManaConfig.gate.option_IDCollectionAndFace')}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col> -->
      </a-col>

      <a-col :span="24" style="margin-top: 16px; text-align: right">
        <a-button type="primary" html-type="submit" :loading="submitting">{{
          $t('devicesManaConfig.gate.submitBtn')
        }}</a-button>
        <a-button :style="{ marginLeft: '8px' }" @click="$emit('backList')">{{
          $t('devicesManaConfig.gate.backBtn')
        }}</a-button>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { setSignInDevice } from '@/api/deviceMana'
import { mapState } from 'vuex'

export default {
  components: {},
  props: {
    deviceConfig: {
      type: Object,
      required: true,
      default: null
    },
    deviceId: {
      type: String,
      required: true,
      default: undefined
    },
    signIn: {
      type: String,
      required: true,
      default: 'false'
    }
  },
  data() {
    return {
      lastDeviceId: null,

      form: this.$form.createForm(this),

      closeDoorAccess: false, // 是否启用门禁功能
      isDirectOpen: false, // 是否启用直接开门功能

      // visitorType: '1', // 访客身份类型
      // S_visitorRecognMode: ['1', '2'], // 预约访客识别方式
      // T_visitorRecognMode: '2', // 临时访客识别方式

      submitting: false
    }
  },
  created() {},
  activated() {
    if (this.deviceId !== this.lastDeviceId) {
      this.lastDeviceId = this.deviceId
      this.initConfig()
    }
  },
  computed: {
    ...mapState(['lang'])
  },
  methods: {
    // 处理进入本类配置的数据
    initConfig() {
      this.$nextTick(() => {
        this.closeDoorAccess = this.deviceConfig.enableDoorAccess === '2'
        // this.isDirectOpen = this.deviceConfig.enableDirectOpen === '1';

        // this.visitorType = this.deviceConfig.visitorType || '1'
        // if (this.visitorType === '1' && this.deviceConfig.visitorRecognMode) {
        //   this.S_visitorRecognMode = this.deviceConfig.visitorRecognMode;
        // }
        // if (this.visitorType === '2' && this.deviceConfig.visitorRecognMode) {
        //   this.T_visitorRecognMode = this.deviceConfig.visitorRecognMode[0];
        // }
      })
    },

    // 提交配置信息
    handleConfigInfoSubmit() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            await setSignInDevice({
              deviceId: this.deviceId,
              isVisitorSignAcDevice: values.signIn === 'true'
            })
          } catch (error) {}
          this.$emit('submitConfig', Object.assign({}, values))
        }
      })
    },

    // 是否启用门禁功能改变
    handleChangeEnableDoorAccess(value) {
      let vm = this

      if (value === '2') {
        this.closeDoorAccess = true
        this.$nextTick(() => {
          this.form.validateFields(
            ['closeDelay', 'doorOpenMode', 'recognMode'],
            { force: true }
          )
        })
      } else {
        this.closeDoorAccess = false
      }
    },
    // 是否启用直接开门功能改变
    handleChangeEnableDirectOpen(value) {
      let vm = this
      if (value === '1') {
        this.isDirectOpen = true
      } else {
        this.isDirectOpen = false
        this.$nextTick(() => {
          this.form.validateFields(['recognMode'], { force: true })
        })
      }
    },
    // 自定义关门延时数值范围校验
    checkCloseDelayRange(rule, value, callback) {
      // console.log('-checkCloseDelayRange-', value)
      if (value && Number(value) > 60) {
        callback(this.$t('devicesManaConfig.gate.closingDelayMax'))
        return
      }
      if (value && Number(value) < 1) {
        callback(this.$t('devicesManaConfig.gate.closingDelayMax'))
        return
      }
      callback()
    },

    // 识别方式改变
    handleRecognModeChange(value) {
      value = this.mutexValuesJudgement(value, [
        ['1', '4'], ['1', '5'], ['1', '6'], ['1', '7'], ['1', '8'],
        ['2', '4'], ['2', '5'], ['2', '6'], ['2', '7'], ['2', '8'],
        ['3', '5'], ['3', '6'], ['3', '7'], ['3', '8'],
        ['4', '5'], ['4', '6'], ['4', '7'], ['4', '8'],
        ['5', '6'], ['5', '7'], ['5', '8'],
        ['6', '7'], ['6', '8'],
        ['7', '8']
        // ['1', '5', '6', '7', '8'],
        // ['5', '6', '7', '8']
      ])

      this.$nextTick(() => {
        this.recognMode = value
        this.form.setFieldsValue({
          recognMode: value
        })
      })
    },
    // 判断多项选择是否选中互斥值, 并返回修改结果
    mutexValuesJudgement(valuesArr, mutex) {
      const lastValue = valuesArr[valuesArr.length - 1]

      // 确定是否有互斥：
      // mutex 中的互斥项依次与 valuesArr 进行比较（即判断 valuesArr 是否包含了互斥项）
      // mutexResArrs 返回的是由 true、false 为值的数组，其中 true 表示 valuesArr 包含了该互斥项，false 反之
      // 只要 mutexResArrs 中有 true，这表示 valuesArr 中的值有互斥
      const mutexResArrs = mutex.map(item =>
        item.every(val => valuesArr.includes(val))
      )
      if (mutexResArrs.includes(true)) {
        // 处理互斥的结果：
        // 通过每个 true 值的序号 index，确定具体是哪一个互斥项 (mutex[index])
        // 然后在 valuesArr 中提出互斥的内容，并插入最新的选择 lastValue
        mutexResArrs.forEach((res, index) => {
          if (res) {
            valuesArr = valuesArr.filter(item => !mutex[index].includes(item))
          }
        })
        valuesArr.push(lastValue)
      }
      return valuesArr
    }

    // 预约访客识别方式改变时
    // handleSVisitorRecognModeChange(value) {
    //   // console.log('---handleSVisitorRecognModeChange----', value)
    //   value = this.mutexValuesJudgement(value, '3');

    //   this.$nextTick(() => {
    //     this.S_visitorRecognMode = value;
    //     this.form.setFieldsValue({
    //       S_visitorRecognMode: value
    //     });
    //   });
    // },
    // 临时访客识别方式改变时
    // handleTVisitorRecognModeChange(value) {
    //   // console.log('---handleTVisitorRecognModeChange----', value)
    //   value = this.mutexValuesJudgement(value, '3');

    //   this.$nextTick(() => {
    //     this.T_visitorRecognMode = value;
    //     this.form.setFieldsValue({
    //       T_visitorRecognMode: value
    //     });
    //   });
    // },
  }
}
</script>

<style scoped></style>
